import * as React from 'react'
import { styled } from '@mui/material/styles'
import {
    Box, Drawer, Toolbar, List, Typography, Divider,
    IconButton, ListItem, ListItemIcon, ListItemText
} from '@mui/material'
import { Menu as MenuIcon, ChevronRight as ChevronRightIcon } from '@mui/icons-material'
import MuiAppBar from '@mui/material/AppBar'
import { connect } from 'react-redux'
import * as common from '../../appRedux/actions/common'
import IntlMessages from '../../util/IntlMessages'
import * as router from '../../constants/router'
import { menuList } from '../../constants/menu'
import config from '../../util/config'
import Routes from '../../routes'
import useStyles from './styles'

const Main = styled('main', { shouldForwardProp: (prop) => prop !== 'open' })(
    ({ theme, open }) => ({
        flexGrow: 1,
        padding: theme.spacing(3),
        transition: theme.transitions.create('margin', {
            easing: theme.transitions.easing.sharp,
            duration: theme.transitions.duration.leavingScreen,
        }),
        marginLeft: `-${config.drawerWidth}px`,
        ...(open && {
            transition: theme.transitions.create('margin', {
                easing: theme.transitions.easing.easeOut,
                duration: theme.transitions.duration.enteringScreen,
            }),
            marginLeft: 0,
        }),
    }),
)

const AppBar = styled(MuiAppBar, {
    shouldForwardProp: (prop) => prop !== 'open',
})(({ theme, open }) => ({
    transition: theme.transitions.create(['margin', 'width'], {
        easing: theme.transitions.easing.sharp,
        duration: theme.transitions.duration.leavingScreen,
    }),
    ...(open && {
        width: `calc(100% - ${config.drawerWidth}px)`,
        marginLeft: `${config.drawerWidth}px`,
        transition: theme.transitions.create(['margin', 'width'], {
            easing: theme.transitions.easing.easeOut,
            duration: theme.transitions.duration.enteringScreen,
        }),
    }),
}))

const DrawerHeader = styled('div')(({ theme }) => ({
    display: 'flex',
    alignItems: 'center',
    padding: theme.spacing(0, 1),
    ...theme.mixins.toolbar,
    justifyContent: 'flex-end',
}))

function DrawerComponent(props) {
    const classes = useStyles()

    const clickListItem = (route) => {
        props.openMenuAction(false)
        props.redirectAction(route)
    }

    return (
        <Box sx={{ display: 'flex' }}>
            <AppBar position="fixed" open={props.menu}>
                <Toolbar>
                    <IconButton
                        color="inherit"
                        onClick={() => props.openMenuAction(true)}
                        edge="start"
                        sx={{ mr: 2, ...(props.menu && { display: 'none' }) }}
                    >
                        <MenuIcon style={{ marginRight: 10 }} fontSize='large' />
                    </IconButton>
                    <Typography variant='h6' noWrap component="div">
                        <IntlMessages id="dobande" />
                    </Typography>
                </Toolbar>
            </AppBar>
            <Drawer
                sx={{
                    width: config.drawerWidth,
                    flexShrink: 0,
                    '& .MuiDrawer-paper': {
                        width: config.drawerWidth,
                        boxSizing: 'border-box',
                        backgroundColor: '#fdd835',
                    },
                }}
                variant="persistent"
                anchor="left"
                open={props.menu}
            >
                <DrawerHeader className={classes.drawerHeader}>
                    <IconButton onClick={() => props.openMenuAction(false)}>
                        <ChevronRightIcon fontSize='large' className={classes.drawerHeaderIcon} />
                    </IconButton>
                </DrawerHeader>
                <Divider />
                <List >
                    {menuList.map((menu, index) => (
                        <ListItem button key={index} onClick={() => clickListItem(menu.router)}>
                            <ListItemIcon>
                                {menu.icon}
                            </ListItemIcon>
                            <ListItemText primary={menu.label} />
                        </ListItem>
                    ))}
                </List>
                <Divider />
                <Typography variant='subtitle1' className={classes.privacy}>
                    <IntlMessages id="privacy" />
                </Typography>
                <Typography variant='body1' className={classes.privacy}>
                    {config.version} : <IntlMessages id="version" />
                </Typography>
            </Drawer>
            <Main open={props.menu}>
                <DrawerHeader />
                <Routes />
            </Main>
        </Box>
    )
}

const mapStateToProps = (state) => {
    return {
        menu: state.common.menu
    }
}

const mapDispatchToProps = (dispatch) => {
    return {
        openMenuAction: (status) => dispatch(common.openMenuAction(status)),
        redirectAction: (router) => dispatch(common.redirectAction(router))
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(DrawerComponent)
